export const banks = [
    { code: "ABB", name: "ABBANK - Ngân hàng An Bình" },
    { code: "ACB", name: "Ngân hàng Á Châu" },
    { code: "AGRIBANK", name: "Ngân hàng Nông nghiệp (Agribank)" },
    { code: "BACABANK", name: "Bắc Á Bank" },
    { code: "BAOVIETBANK", name: "Bảo Việt Bank" },
    { code: "BIDV", name: "Ngân hàng Đầu tư và Phát triển (BIDV)" },
    { code: "CBBANK", name: "Ngân hàng Xây Dựng (CBBank)" },
    { code: "CIMB", name: "CIMB Bank" },
    { code: "COOPBANK", name: "Ngân hàng Hợp tác xã VN (Co-op Bank)" },
    { code: "DONGABANK", name: "DongABank" },
    { code: "EXIMBANK", name: "Eximbank" },
    { code: "GPBANK", name: "GPBank" },
    { code: "HDBANK", name: "HDBank" },
    { code: "HLBVN", name: "HongLeong Bank" },
    { code: "IBK-HCM", name: "IBK HCM" },
    { code: "IBK-HN", name: "IBK HN" },
    { code: "INDOVINABANK", name: "Indovina Bank" },
    { code: "KASIKORNBANK", name: "KBank - Kasikornbank" },
    { code: "KIENLONGBANK", name: "Kienlongbank" },
    { code: "KOOKMINBANK", name: "Kookmin Bank" },
    { code: "LPB", name: "LienVietPostBank" },
    { code: "MSB", name: "Maritime Bank" },
    { code: "MB", name: "MB Bank" },
    { code: "NAMABANK", name: "Nam Á Bank" },
    { code: "NCB", name: "Ngân hàng Quốc Dân (NCB)" },
    { code: "OCB", name: "OCB" },
    { code: "OCEANBANK", name: "OceanBank" },
    { code: "PGBANK", name: "PG Bank" },
    { code: "PUBLICBANK", name: "Public Bank Vietnam" },
    { code: "PVCOMBANK", name: "PVcomBank" },
    { code: "SACOMBANK", name: "Sacombank" },
    { code: "SAIGONBANK", name: "SaigonBank" },
    { code: "SCB", name: "SCB" },
    { code: "SEABANK", name: "SeABank" },
    { code: "SHB", name: "SHB" },
    { code: "SHINHANBANK", name: "Shinhan Bank" },
    { code: "STANDARDCHARTERED", name: "Standard Chartered Bank" },
    { code: "TECHCOMBANK", name: "Techcombank" },
    { code: "TPB", name: "TPBank" },
    { code: "UOB", name: "UOB" },
    { code: "VCB", name: "Vietcombank" },
    { code: "VIB", name: "VIB" },
    { code: "VIDBANK", name: "VID Public Bank" },
    { code: "VIETABANK", name: "VietABank" },
    { code: "VIETBANK", name: "VietBank" },
    { code: "VIETCAPITALBANK", name: "VietCapitalBank" },
    { code: "VIETINBANK", name: "VietinBank" },
    { code: "VPB", name: "VPBank" },
    { code: "VRB", name: "VRB" },
    { code: "WOOREEBANK", name: "Woori Bank" },
  ];